import { openBlock as e, createElementBlock as c, createElementVNode as o } from "vue";
const t = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 17"
}, l = /* @__PURE__ */ o("path", {
  fill: "#0D141F",
  "fill-rule": "evenodd",
  d: "M0 16.215V.37h3.582a15 15 0 0 1-.141 1.514c-.065.469-.132.958-.215 1.461l-.009.056a55 55 0 0 1-.32 1.836h.664c.284-1.17.647-2.136 1.1-2.92.454-.773 1.01-1.352 1.68-1.738C6.997.193 7.768 0 8.63 0c.964 0 1.758.227 2.382.67s1.1 1.057 1.43 1.83c.328.773.532 1.682.623 2.704h.488c.26-1.17.635-2.136 1.134-2.897.488-.762 1.1-1.341 1.815-1.727a4.9 4.9 0 0 1 2.37-.58c.862 0 1.588.17 2.235.511s1.18.841 1.61 1.5c.431.66.76 1.477.964 2.466.216.989.318 2.125.318 3.42v8.318h-3.834v-7.83c0-1.124-.09-2.067-.283-2.806-.193-.75-.488-1.307-.874-1.682-.396-.375-.896-.556-1.52-.556-.703 0-1.315.227-1.837.693s-.93 1.113-1.236 1.954-.476 1.784-.545 2.852v7.375H10.13V8.568c0-1.17-.102-2.137-.307-2.92-.204-.773-.499-1.353-.907-1.74-.397-.386-.919-.579-1.543-.579a2.6 2.6 0 0 0-1.86.728c-.51.488-.918 1.147-1.202 2-.295.84-.454 1.795-.499 2.84v7.318z",
  "clip-rule": "evenodd"
}, null, -1), n = [
  l
];
function r(s, d) {
  return e(), c("svg", t, [...n]);
}
const h = { render: r };
export {
  h as default,
  r as render
};
